module.exports = __webpack_public_path__ + "static/Niamh2-c73c73e3e5288f08d3f4619da6b20252.jpg";